import { gql } from "@apollo/client";

export type AdminAuthResponse = {
  __typename: 'AdminAuthResponse';
  status: 'success';
};

export const ADMIN_AUTH_RESPONSE_FRAGMENT = gql`
  fragment AdminAuthResponseFragment on AdminAuthResponse {
    __typename
    status
  }
`;
